import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const Call = ({ changes: { stop, carrier }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        Stop: {stop}
      </Text>
      <Text color="grey800" display="block">
        Carrier: {carrier}
      </Text>
    </Spacer>
  );
};

export default Call;
